// 调账

import { HttpBillCoefficientList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpBillCoefficientList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.operate = {
                        title: '添加配置',
                        show: true,
                        width: 'middle',
                        querytype: 'add',
                        querybox: true,
                        component: "comIndex",
                        showFooter: false,
                    }
                    break;
                case "edit":
                    this.operate = {
                        title: this.$t('global.common.edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 'middle',
                        component: "comIndex",
                        activeids: params,
                        querytype: 'edit',
                        querybox: true,
                        showFooter: false
                    }
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 'middle',
                        component: "comIndex",
                        activeids: params,
                        querytype: 'query',
                        querybox: true,
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "billCoefficientUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/costAdjustment/export", this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/customerBillRate/importRate",
                        accept: '.xls, .xlsx',
                        name: 'multipartFile',
                        component: 'compUpload',
                        download: () => {
                            this.handleWebfs( process.env.VUE_APP_APIURL_FBB + "/api/v2/customerBillRate/itemTemplate", "download");
                        },
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: true,
                    params: id,
                    operate: 'edit'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                // {
                //     name: "导出",
                //     operate: "export",
                //     theme: "info",
                // },
                {
                    name: "导入",
                    operate: "upload",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'EQ_orgId',
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    tag: "vSelect",
                    key: "EQ_lineId",
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: '操作',
                    maxWidth: 80,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'orgId',
                    render: (h, { row }) => {
                        const org = this.getBillcusorgList.filter( item=> item.value === row.orgId)[0] || {};
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{org.label || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    render: (h, { row }) => this.findRenderLabel( this.getCusproductList, row.lineId ) || '--'
                },
                {
                    title: "仓储费-常规件计费系数",
                    key: 'normalCoefficient',
                },
                {
                    title: "仓储费-异形件计费系数",
                    key: 'specialCoefficient',
                },
                {
                    title: "仓储费-超异形件计费系数",
                    key: 'superSpecialCoefficient',
                },
                {
                    title: "更新人",
                    key: 'updatedName',
                },
                {
                    title: "更新时间",
                    key: 'updatedAt',
                }];
        },
    },
};




